<template>
    <!-- 附件 弹框 -->
    <el-dialog
        class="feeAllpyAttachment"
        :title="isReject?'驳 回':'附 件'"
        :visible="true"
        :before-close="()=>{$emit('close-dialog','netAttachmentShow')}"
        width="600px"
    >
        <div class="carryBox" v-loading="loading">
                <div class="attachmentTitle">
                    <el-row :gutter="20">
                        <el-col :span="13">
                            <div class="grid-content bg-purple">
                                <span>上传人：{{updateUserName}}</span>
                            </div>
                        </el-col>
                        <el-col :span="11">
                            <div class="grid-content bg-purple">
                                <span>上传时间：{{updateTime}}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="attachmentLeft">
                    <div :class="{ viewerBox:!isReject, viewerBoxRj:isReject }">
                        <ul id="viewers">
                            <li v-for="(item, index) in imgArr" :key="index">
                                <img :src="item.imageUrl"/>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- <el-input
                    type="text"
                    v-model="rejectFeeReason"
                    placeholder="可输入驳回原因"
                    v-if="isReject"
                ></el-input> -->
            </div>
            <div slot="footer" class="dialog-footer" v-if="isReject">
                <el-button @click="closeDialogOnly">取 消</el-button>
                <el-button type="primary" @click="rejectConfirm">驳 回</el-button>
            </div>
    </el-dialog>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import apiImg from '../../../../api/netTaskManage2c.js';
import api from '../../../../api/requestFeeApply';

export default {
    props: {
        rowData: {
            type: Object,
            default() {
                return {};
            }
        },
        isReject: {
            type: Boolean,
            defult() {
                return false;
            }
        }
    },
    data() {
        return {
            loading: false,
            viewer: {},
            carouselIndex: 0, // 轮播图当前的索引
            imgArr: [],
            updateUserName: '',
            updateTime: '',
            rejectFeeReason: ''
        };
    },
    created() {
        this.getImgList();
    },
    methods: {
        async getImgList() {
            this.loading = true;
            this.imgArr = [];
            const params = {
                orderNo: this.rowData.orderNo,
                type: '10',
                pageNo: 1,
                pageSize: 1000
            };
            await apiImg
                .orderImages(params)
                .then((res) => {
                    if (res) {
                        this.imgArr = res.data.list.reverse() || [];
                        this.initShow();
                    }
                })
                .catch(() => {});
            this.loading = false;
        },
        initViewer() {
            const barOptions = { show: true, size: 'small' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: true,
                button: true,
                view: (info) => {
                    this.carouselIndex = info.detail.index;
                    this.updateInfo();
                },
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    prev: barOptions,
                    reset: barOptions,
                    next: barOptions,
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
        },
        updateInfo () {
            this.updateUserName = this.imgArr[this.carouselIndex].updateUserName;
            this.updateTime = this.imgArr[this.carouselIndex].updateTime;
        },
        initShow() {
            this.carouselIndex = 0;
            this.updateUserName = this.imgArr.length ? this.imgArr[0].updateUserName : '';
            this.updateTime = this.imgArr.length ? this.imgArr[0].updateTime : '';
            this.$nextTick(() => {
                this.initViewer();
            });
        },
        async rejectConfirm() {
            this.loading = true;
            const params = [
                {
                    id: this.rowData.id,
                    orderNo: this.rowData.orderNo,
                    customerOrderNo: this.rowData.customerOrderNo,
                    applystatus: 3,
                    townCode: this.rowData.townCode
                    // rejectFeeReason: this.rejectFeeReason
                }
            ];
            await api
                .saveItems(params)
                .then((res) => {
                    if (res && res.code === '0') {
                        this.$message.success('操作成功');
                        this.$emit('close-dialog', 'netAttachmentShow', true);
                    }
                })
                .catch(() => {});
            this.loading = false;
        },
        closeDialogOnly() {
            this.$emit('close-dialog', 'netAttachmentShow');
        }
    }
};
</script>

<style lang="less">
.feeAllpyAttachment {
    .el-input__inner {
        border: 1px solid #33C9CC;
    }
    .viewerBox {
        height: 350px;
    }
    .viewerBoxRj {
        height: 250px;
        margin-bottom: 20px;
    }
    #viewers {
            display: none;
        }
    .attachmentTitle {
        margin: 10px 0;
    }
        .carousel {
            text-align: center;
            .receiveImgs {
                height: 100%;
            }
        }
        .viewer-backdrop.viewer-fixed {
            background-color: rgba(0, 0, 0, 0.5);
        }
        .viewer-backdrop {
            background-color: #fff;
        }
        .viewer-backdrop.viewer-fixed {
            background-color: rgba(0, 0, 0, 0.5);
        }
        .viewer-button {
            width: 60px;
            height: 60px;
            top: -30px;
            right: -30px;
        }
        .viewer-button::before {
            bottom: 10px;
            left: 10px;
        }
        .viewer-button.viewer-fullscreen-exit {
            width: 80px;
            height: 80px;
            top: -40px;
            right: -40px;
        }
        .viewer-button.viewer-fullscreen-exit::before {
            bottom: 15px;
            left: 15px;
        }
        .viewer-toolbar > ul > .viewer-small {
            margin: 3px;
        }
}
</style>
